import { render, staticRenderFns } from "./livevideo.vue?vue&type=template&id=046b62ff&scoped=true&"
import script from "./livevideo.vue?vue&type=script&lang=js&"
export * from "./livevideo.vue?vue&type=script&lang=js&"
import style0 from "./livevideo.vue?vue&type=style&index=0&id=046b62ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b62ff",
  null
  
)

export default component.exports